/**
 * Prevents an element's default action unless the user confirms the action
 *
 * Usage:
 *   data-sw-confirm-message=<message to display>
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw  = require('js/lib/sw');

$(document).ready(function() {
  $('body').on('click', '[data-sw-confirm]', function(e) {
    var message = $(this).attr('data-sw-confirm-message');

    if(!window.confirm(message)) {
      e.preventDefault();
    }
  });

  /**
   * Displays a UX friendly confirm dialog (noty) when submitting a form and sends tracking information to mixpanel if tracking attribute is present.
   *
   * data-sw-confirm-submit=<message to display>
   * data-sw-confirm-submit-tracking=<tracking information>
   */
  $('body').on('submit', '[data-sw-confirm-submit]', function(e) {
    if (!$(this).data('isSubmitted')) {
      e.preventDefault();

      var $form = $(this);
      var message = $form.attr('data-sw-confirm-submit');
      var eventName = 'sw-confirm-form-submit';

      sw.on(eventName, function () {
        $form.data('isSubmitted', true);
        $form.submit();
      });

      sw.notifications.confirm(message, '', eventName);
    }
  });
});
